import IconCard from "../../components/IconCard/IconCard";
import AuctionList from "../AuctionList/AuctionList";
import Cover from "./Cover/Cover";
import Discover from "./Discover/Discover";
import GettingStarted from "./GettingStarted/GettingStarted";
import PopularCollections from "./PopularCollections/PopularCollections";
import TopCollections from "./TopCollections/TopCollections";
import './Home.css';

const Home = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20">
            
            <div className="mb-6 sm:mb-20 pt-10 md:pt-20">
                <Cover />
            </div>

            <div className="py-14 sm:py-20 mb-6 sm:mb-10">
                <AuctionList />
            </div>

            <div className="py-14 sm:py-20 mb-6 sm:mb-10">
                <PopularCollections />
            </div>

            <div>
                <TopCollections />
            </div>

            <div className="py-10 mb-6 sm:mb-10">
                <GettingStarted />
            </div>

            <div className="mb-10 sm:mb-20 w-full max-w-[1200px] mx-auto justify-center flex flex-col items-center ">
                <p className="text-center text-sm sm:text-base mb-14 tracking-wider">
                    Eu, molestie commodo, enim pellentesque turpis integer sagittis
                </p>
                <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-5 justify-items-center">
                    <IconCard image = {require('../../assets/images/homeicons/1.png')} text = "Connect Your Wallet" />
                    <IconCard image = {require('../../assets/images/homeicons/2.png')} text = "Posuere urna, sit amet molestie leo" />
                    <IconCard image = {require('../../assets/images/homeicons/3.png')} text = "Semper pretium libero sed quam ac integer ut" />
                    <IconCard image = {require('../../assets/images/homeicons/4.png')} text = "Lectus volutpat magna vitae in arcu" />
                </div>
            </div>

            <div className="mb-20">
                <Discover />
            </div>

            
            <div className="flex flex-col justify-center items-center mb-10">
                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    Meet IOWNNFT
                </h1>
                <p className="text-center text-sm sm:text-base text-gray-400 tracking-wider">
                    The NFT Marketplace with everything for everyone
                </p>
            </div>
            <div className="flex justify-center mb-20 md:mb-32">
                <iframe className = 'responsive_youtube' src="https://www.youtube.com/embed/gfGuPd1CELo?list=TLGG0LpIW2LMI8cwODA2MjAyMg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

        


            

            <div className="absolute w-[100px] h-[100px] bg-[#FB37FF] top-[10%] right-[35%] blur-[95px]">
            </div>
            <div className="absolute w-[100px] h-[100px] bg-[#18B2DE] bottom-[10%] right-[5%] blur-[95px]">
            </div>
        </div>
    )
}

export default Home;